module.exports = __webpack_public_path__ + "img/circle-square.e38c7834.svg";